"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _hooks = require("../../../hooks");
var _icons = require("../../icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function RankCard({
  challengeTemplate,
  progress,
  numberOfParticipants
}) {
  const {
    getProgressValue
  } = (0, _hooks.useChallenge)();
  const {
    toOrdinal
  } = (0, _hooks.useUnits)();
  if (!challengeTemplate || progress === null) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    bgcolor: progress ? '#FFF5D0' : '#efefef',
    borderRadius: 2,
    display: "flex",
    flexDirection: "row",
    flexShrink: 0,
    gap: 1,
    padding: 2,
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_icons.CupIcon, {
    fontSize: "small",
    sx: {
      color: progress ? '#EBAF25' : 'rgba(0, 0, 0, 0.54)'
    }
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, progress && numberOfParticipants !== undefined ? /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    components: [/*#__PURE__*/_react.default.createElement("span", {
      key: 0,
      style: {
        fontWeight: 700
      }
    })],
    count: numberOfParticipants,
    i18nKey: "commons.challenges.rank",
    values: {
      rank: progress.rank !== undefined ? toOrdinal(progress.rank, {
        inclusive: true
      }) : '-',
      count: numberOfParticipants,
      progress: getProgressValue(challengeTemplate.type, progress.progressValue)
    }
  }) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })));
}
var _default = exports.default = RankCard;